import { Reveal } from "@/components/site/Motion";

const EXAMPLES = [
  { src: "/media/models/anita-p/08.jpg", label: "Face", note: "Straight to camera, hair back" },
  { src: "/media/models/andrea-j/01.jpg", label: "Profile", note: "Side view, chin level" },
  { src: "/media/models/alina-a/01.jpg", label: "Half body", note: "Waist up, arms relaxed" },
  { src: "/media/models/alicia-z/18.jpg", label: "Full length", note: "Head to toe, fitted clothes" },
];

const RULES = ["Daylight, plain wall", "No make-up, no filters", "No glasses or hands on face", "Fitted clothes, hair back"];

export const PhotoExamples = () => (
  <Reveal className="mt-14" >
    <div data-testid="apply-photo-examples">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">What to send · Polas &amp; snaps</p>
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {EXAMPLES.map((e) => (
          <figure key={e.label} data-testid={`apply-example-${e.label.toLowerCase().replace(/ /g, "-")}`}>
            <div className="aspect-[3/4] overflow-hidden bg-[#f4f4f4]">
              <img src={e.src} alt={`${e.label} example`} loading="lazy" className="h-full w-full object-cover object-top" />
            </div>
            <figcaption className="mt-2">
              <span className="block font-display text-xl uppercase leading-none">{e.label}</span>
              <span className="mt-1 block text-xs text-[#1c1418]/70">{e.note}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-2 border-t border-[#1c1418]/15 pt-4 font-mono text-[11px] uppercase tracking-[0.15em]">
        {RULES.map((r) => <li key={r}>— {r}</li>)}
      </ul>
      <p className="mt-3 text-xs text-[#1c1418]/60">Examples from models on our board.</p>
    </div>
  </Reveal>
);
